import * as Dialog from '@radix-ui/react-dialog'

import { FxButton } from '@/components/fx'

/**
 * A yes/no dialog for the one destructive action on this tab.
 *
 * The retired admin build asked with `window.confirm`, which cannot be styled,
 * cannot explain what cancelling actually does, and reads in the browser's
 * language rather than the product's. Radix carries the focus trap, Escape and
 * the return of focus to the button that opened it.
 *
 * (The cockpit's template tab has an equivalent in
 * `pages/cockpit/template/DialogShell.tsx`. Promoting one of them into
 * `components/` is the right end state and is a change of its own — that
 * directory belongs to another agent this wave.)
 */
export function ConfirmDialog({
  open,
  onClose,
  title,
  description,
  confirmLabel,
  pending,
  onConfirm,
}: {
  open: boolean
  onClose: () => void
  title: string
  description: React.ReactNode
  confirmLabel: string
  pending?: boolean
  onConfirm: () => void
}) {
  return (
    <Dialog.Root open={open} onOpenChange={(next) => !next && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-[#0000008c]" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-[min(520px,calc(100vw-40px))] -translate-x-1/2 -translate-y-1/2 rounded-xl bg-surface p-5 shadow-overlay xs:p-8">
          <Dialog.Title className="mb-4 text-dialog-title text-text">{title}</Dialog.Title>
          <Dialog.Description asChild>
            <div className="mb-6 text-body text-text">{description}</div>
          </Dialog.Description>
          <div className="flex flex-wrap justify-end gap-3">
            <FxButton variant="outlined" onClick={onClose}>
              Schließen
            </FxButton>
            <FxButton variant="danger" disabled={pending} onClick={onConfirm}>
              {confirmLabel}
            </FxButton>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
